export default "__VITE_PUBLIC_ASSET__9929859d__"